import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            insuranceProduct: '',
            component: 'LifeAndHealthInsurance',
            agree: ''
        }
    },
    getters: {
        insuranceProduct(state){
            return state.insuranceProduct;
        },
        component(state){
            return state.component;
        },
        agree(state){
            return state.agree;
        }
    },
    mutations: {
        [mns.SET_INSURANCE_PRODUCT](state, insuranceProduct){
            state.insuranceProduct = insuranceProduct;
        },
        [mns.SET_COMPONENT](state, component){
            state.component = component;
        },
        [mns.SET_AGREE](state, value){
            state.agree = value;
        }
    }
} // export.